import { request } from '@/request/request';

export default {
  // 获取考核试卷配置（固定卷题目 / 随机规则）
  getPaper(params) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_paper/getPaper`,
      method: 'get',
      params,
    });
  },
  // 切换组卷模式（0固定卷/1随机抽题）
  setPaperMode(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_paper/setPaperMode`,
      method: 'post',
      data,
    });
  },
  // 保存固定卷
  saveFixedPaper(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_paper/saveFixedPaper`,
      method: 'post',
      data,
    });
  },
  // 从题库追加题目到固定卷
  paperAddQuestions(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_paper/addQuestions`,
      method: 'post',
      data,
    });
  },
  // 从固定卷移除题目
  paperRemoveQuestion(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_paper/removeQuestion`,
      method: 'post',
      data,
    });
  },
  // 保存随机抽题规则
  saveRules(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_paper/saveRules`,
      method: 'post',
      data,
    });
  },
  // 随机卷试生成预览
  previewRandom(params) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/exam_paper/previewRandom`,
      method: 'get',
      params,
    });
  },
};
